import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { getVisits } from '../actions'
import {
  dashboardStartDateSelector,
  dashboardEndDateSelector
} from '../selectors/dashboardSelectors'

export const getRoomsForTransfer = createAsyncThunk(
  'roomTransfer/getRoomsForTransfer',
  (_, { getState }) => {
    const state = getState()
    return axios
      .get('/api/transfer/availableRooms', {
        params: {
          selectedVisits: state.roomTransfer.selectedVisits,
          isSwap: state.roomTransfer.roomTransferMode === 'room-swap'
        }
      })
      .then(res => res.data)
      .catch(e => console.log(e))
  }
)

export const moveVisitsFinal = createAsyncThunk(
  '/transfer/moveVisits',
  (_, { dispatch, getState }) => {
    const state = getState()
    try {
      return axios
        .get('api/transfer/moveVisits', {
          params: {
            selectedVisits: state.roomTransfer.selectedVisits,
            selectedRoom: state.roomTransfer.currentlySelectedRoom,
            isSwap: state.roomTransfer.roomTransferMode === 'room-swap'
          }
        })
        .then(res => {
          const startDate = dashboardStartDateSelector(state)
          const endDate = dashboardEndDateSelector(state)
          dispatch(getVisits(startDate.toDate(), endDate.toDate()))
          return res.data
        })
    } catch (e) {
      console.log(e)
    }
  }
)

const initialState = {
  status: 'initial',
  selectedVisits: [],
  showDialog: false,
  totalAvailableRooms: { status: false, list: [] },
  isLoading: false,
  selectVisitsFromSameRoom: true,
  newRoomSelected: true,
  roomTransferSuccess: 'initial',
  roomTransferMode: 'room-transfer',
  isVistsMovedLoading: false
}

export const roomTransferModule = createSlice({
  name: 'roomTransfer',
  initialState,
  reducers: {
    startTransfer(state, action) {
      state.status = 'active'
      state.selectRoomWarning = false
    },
    continueTransfer(state, action) {
      state.status = 'active'
    },
    cancelTransfer(state) {
      state.status = 'initial'
      state.selectedVisits = []
    },
    openAvailRoomsDialog(state, action) {
      state.showDialog = state.selectedVisits.length > 0
      state.currentlySelectedRoom = null
      state.totalAvailableRooms.status = false
      state.selectRoomWarning = state.selectedVisits.length === 0
      state.roomTransferSuccess = 'initial'
    },
    closeAvailRoomsDialog(state, action) {
      state.showDialog = false
      state.roomTransferMode = 'room-transfer'
    },
    selectVisit(state, action) {
      if (state.selectedVisits.includes(action.payload)) {
        state.selectedVisits = state.selectedVisits.filter(
          visit => visit !== action.payload
        )
      } else {
        state.selectedVisits.push(action.payload)
      }
      state.selectRoomWarning = state.selectedVisits.length < 1
    },
    selectAvailableRoom(state, action) {
      state.currentlySelectedRoom = action.payload
      state.newRoomSelected = state.currentlySelectedRoom !== null
    },
    deselectVisit(state, action) {
      state.selectedVisits = state.selectedVisits.filter(
        visit => visit !== action.payload
      )
    },
    showtotalAvailableRooms(state, action) {
      if (action.payload === false) {
        state.totalAvailableRooms.status = true
      } else {
        state.totalAvailableRooms.status = false
      }
    },
    saveTransferredVisits(state, action) {
      state.newRoomSelected = state.currentlySelectedRoom !== null
    },
    setRoomTransferMode(state, action) {
      state.roomTransferMode =
        action.payload === 'room-swap' ? 'room-swap' : 'room-transfer'
      state.currentlySelectedRoom = null
    }
  },
  extraReducers: builder => {
    // This will load the spinner until the data gets fetched
    builder.addCase(getRoomsForTransfer.pending, (state, action) => {
      state.isLoading = true
      state.totalAvailableRooms.list = []
    })

    // Add reducers for additional action types here, and handle loading state as needed
    builder.addCase(getRoomsForTransfer.fulfilled, (state, action) => {
      // Do something with the results
      if (action.payload.rooms) {
        state.totalAvailableRooms.list = action.payload.rooms
        state.selectVisitsFromSameRoom = true
      } else {
        state.totalAvailableRooms.list = []
        state.selectVisitsFromSameRoom = false
      }
      state.isLoading = false
    })

    builder.addCase(moveVisitsFinal.pending, (state, action) => {
      state.isVistsMovedLoading = true
    })

    builder.addCase(moveVisitsFinal.fulfilled, (state, action) => {
      state.isVistsMovedLoading = false
      if (action.payload.status === 'success') {
        state.roomTransferSuccess = 'success'
      } else {
        state.roomTransferSuccess = 'error'
      }
    })
  }
})

export const {
  startTransfer,
  cancelTransfer,
  continueTransfer,
  selectVisit,
  selectAvailableRoom,
  openAvailRoomsDialog,
  closeAvailRoomsDialog,
  showtotalAvailableRooms,
  saveTransferredVisits,
  setRoomTransferMode,
  resetRoomTransferMode
} = roomTransferModule.actions



// WEBPACK FOOTER //
// ./src/redux/modules/roomTransferModule.js